/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type CreateOrUpdatePriorityLevelsBulkInput = {
    priorityLevels?: Array<PriorityLevelBulk | null> | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type PriorityLevelBulk = {
    id?: string | null | undefined;
    name?: string | null | undefined;
    disabled?: boolean | null | undefined;
};
export type createOrUpdatePriorityLevelsBulkMutationModernMutationVariables = {
    input: CreateOrUpdatePriorityLevelsBulkInput;
};
export type createOrUpdatePriorityLevelsBulkMutationModernMutationResponse = {
    readonly createOrUpdatePriorityLevelsBulk: {
        readonly company: {
            readonly priorityLevels: {
                readonly edges: ReadonlyArray<{
                    readonly node: {
                        readonly id: string;
                        readonly name: string | null;
                        readonly weight: number | null;
                        readonly disabled: boolean | null;
                    } | null;
                } | null> | null;
            } | null;
        } | null;
    } | null;
};
export type createOrUpdatePriorityLevelsBulkMutationModernMutation = {
    readonly response: createOrUpdatePriorityLevelsBulkMutationModernMutationResponse;
    readonly variables: createOrUpdatePriorityLevelsBulkMutationModernMutationVariables;
};



/*
mutation createOrUpdatePriorityLevelsBulkMutationModernMutation(
  $input: CreateOrUpdatePriorityLevelsBulkInput!
) {
  createOrUpdatePriorityLevelsBulk(input: $input) {
    company {
      priorityLevels(first: 1000) {
        edges {
          node {
            id
            name
            weight
            disabled
            __typename
          }
          cursor
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateOrUpdatePriorityLevelsBulkInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PriorityLevelTypeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PriorityLevel",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "weight",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "disabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "PageInfo",
    "kind": "LinkedField",
    "name": "pageInfo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "endCursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasNextPage",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v4 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createOrUpdatePriorityLevelsBulkMutationModernMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateOrUpdatePriorityLevelsBulkPayload",
        "kind": "LinkedField",
        "name": "createOrUpdatePriorityLevelsBulk",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              {
                "alias": "priorityLevels",
                "args": null,
                "concreteType": "PriorityLevelTypeConnection",
                "kind": "LinkedField",
                "name": "__Company_priorityLevels_connection",
                "plural": false,
                "selections": (v3/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createOrUpdatePriorityLevelsBulkMutationModernMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateOrUpdatePriorityLevelsBulkPayload",
        "kind": "LinkedField",
        "name": "createOrUpdatePriorityLevelsBulk",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v4/*: any*/),
                "concreteType": "PriorityLevelTypeConnection",
                "kind": "LinkedField",
                "name": "priorityLevels",
                "plural": false,
                "selections": (v3/*: any*/),
                "storageKey": "priorityLevels(first:1000)"
              },
              {
                "alias": null,
                "args": (v4/*: any*/),
                "filters": [],
                "handle": "connection",
                "key": "Company_priorityLevels",
                "kind": "LinkedHandle",
                "name": "priorityLevels"
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {
      "connection": [
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "createOrUpdatePriorityLevelsBulk",
            "company",
            "priorityLevels"
          ]
        }
      ]
    },
    "name": "createOrUpdatePriorityLevelsBulkMutationModernMutation",
    "operationKind": "mutation",
    "text": "mutation createOrUpdatePriorityLevelsBulkMutationModernMutation(\n  $input: CreateOrUpdatePriorityLevelsBulkInput!\n) {\n  createOrUpdatePriorityLevelsBulk(input: $input) {\n    company {\n      priorityLevels(first: 1000) {\n        edges {\n          node {\n            id\n            name\n            weight\n            disabled\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '11589e648396bbb6991433c9cd5d6467';
export default node;
